import { Toast } from "@elaniintc/goes-design-system";

export function ToastProvider() {
  return (
    <Toast
      position="bottom-right"
      toastOptions={{
        unstyled: true,
      }}
    />
  );
}
export default ToastProvider;
